import { render, staticRenderFns } from "./GroupMailStatView.vue?vue&type=template&id=1e5643f9&scoped=true&"
import script from "./GroupMailStatView.vue?vue&type=script&lang=js&"
export * from "./GroupMailStatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5643f9",
  null
  
)

export default component.exports